import { createActionGroup, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { IServerSideGetRowsRequest } from 'ag-grid-community/dist/types/src/interfaces/iServerSideDatasource';
import { ScorecardResult } from '../../../../../../graphql';

export const SCORECARD_QUESTION_API_ACTIONS = createActionGroup({
  source: 'Scorecard Questions SSR API',
  events: {
    get: props<{ request: IServerSideGetRowsRequest }>(),
    success: props<{ rows: ScorecardResult[]; totalCount: number }>(),
    error: props<{ error: HttpErrorResponse }>(),
  },
});

export const SCORECARD_QUESTION_ACTIONS = createActionGroup({
  source: 'Scorecard Questions Report',
  events: {
    setActiveView: props<{ viewName: string | null }>(),
  },
});
